import useSWRMutation from "swr/mutation";
import { CreateMeasurementRequestComment } from "@/types/measurementRequestComment";
import { SWRApiError, useDeleter, useMutater } from "./swr";

export const useCreateMeasurementRequestComment = (measurementRequestId: number) => {
  const mutater = useMutater();

  return useSWRMutation<void, SWRApiError, string, CreateMeasurementRequestComment>(
    `/measurement_requests/${measurementRequestId}/comments`,
    mutater,
  );
};

export const useDeleteMeasurementRequestComment = (measurementRequestId: number) => {
  const deleter = useDeleter();

  return useSWRMutation<void, SWRApiError, string, { id: string | number }>(
    `/measurement_requests/${measurementRequestId}/comments`,
    deleter,
  );
};
